import { Action } from '@ngrx/store';
import { Building, BuildingLevel, CompanyBuildingUnitView, BuildingUnit } from '../../models';

export enum BuildingActionTypes {
  LoadBuildings = '[Building] Load Buildings',
  LoadBuildingsSuccess = '[Building] Load Buildings Success',
  LoadBuildingsFail = '[Building] Load Buildings Fail',

  LoadBuildingLevels = '[Building] Load Building Levels',
  LoadBuildingLevelsSuccess = '[Building] Load Building Levels Success',
  LoadBuildingLevelsFail = '[Building] Load Building Levels Fail',

  LoadBuildingUnits = '[Building] Load Building Units',
  LoadBuildingUnitsSuccess = '[Building] Load Building Units Success',
  LoadBuildingUnitsFail = '[Building] Load Building Units Fail',

  LoadAllBuildingUnits = '[Building] Load All Building Units',
  LoadAllBuildingUnitsSuccess = '[Building] Load All Building Units Success',
  LoadAllBuildingUnitsFail = '[Building] Load All Building Units Fail',
}


export class LoadBuildings implements Action {
  readonly type = BuildingActionTypes.LoadBuildings;
}

export class LoadBuildingsFail implements Action {
  readonly type = BuildingActionTypes.LoadBuildingsFail;
  constructor(public payload: any) { }
}

export class LoadBuildingsSuccess implements Action {
  readonly type = BuildingActionTypes.LoadBuildingsSuccess;
  constructor(public payload: Building[]) { }
}

export class LoadBuildingLevels implements Action {
  readonly type = BuildingActionTypes.LoadBuildingLevels;
}

export class LoadBuildingLevelsFail implements Action {
  readonly type = BuildingActionTypes.LoadBuildingLevelsFail;
  constructor(public payload: any) { }
}

export class LoadBuildingLevelsSuccess implements Action {
  readonly type = BuildingActionTypes.LoadBuildingLevelsSuccess;
  constructor(public payload: BuildingLevel[]) { }
}

export class LoadBuildingUnits implements Action {
  readonly type = BuildingActionTypes.LoadBuildingUnits;
  constructor(public payload: { companyId: number, filterUnits: boolean }) { }
}

export class LoadBuildingUnitsFail implements Action {
  readonly type = BuildingActionTypes.LoadBuildingUnitsFail;
  constructor(public payload: any) { }
}

export class LoadBuildingUnitsSuccess implements Action {
  readonly type = BuildingActionTypes.LoadBuildingUnitsSuccess;
  constructor(public payload: CompanyBuildingUnitView[]) { }
}


export class LoadAllBuildingUnits implements Action {
  readonly type = BuildingActionTypes.LoadAllBuildingUnits;
}

export class LoadAllBuildingUnitsFail implements Action {
  readonly type = BuildingActionTypes.LoadAllBuildingUnitsFail;
  constructor(public payload: any) { }
}

export class LoadAllBuildingUnitsSuccess implements Action {
  readonly type = BuildingActionTypes.LoadAllBuildingUnitsSuccess;
  constructor(public payload: BuildingUnit[]) { }
}

export type BuildingAction =
  | LoadBuildings
  | LoadBuildingsFail
  | LoadBuildingsSuccess

  | LoadBuildingLevels
  | LoadBuildingLevelsFail
  | LoadBuildingLevelsSuccess

  | LoadBuildingUnits
  | LoadBuildingUnitsFail
  | LoadBuildingUnitsSuccess

  | LoadAllBuildingUnits
  | LoadAllBuildingUnitsFail
  | LoadAllBuildingUnitsSuccess
  ;



// WEBPACK FOOTER //
// ./src/app/core/store/actions/building.actions.ts